import AboutGuide from "../../Components/AboutGuide";
import styles from "../../Styles/Homepage.module.scss";
import { useParams } from "react-router-dom";

function Homepage() {
  const params = useParams();

  let dates = "";
  let title = "";

  switch (params.trip) {
    case "September-2026":
      dates = "September 29 - October 10, 2026";
      title = "Israel & Petra";
      break;
    case "October-2026":
      dates = "October 20 - 30, 2026";
      title = " Israel";
      break;
    case "trip":
      dates = "";
      title = "Israel & Petra";
      break;
  }
  return (
    <div className={styles.backgroundPictureIsrael}>
      <div className={styles.titleBox}>
        <h1>Visit the land of the Bible</h1>
        <p className={styles.title}>{title}</p>
        <p className={styles.dates}>{dates}</p>
        <div className={styles.description}>
          <p>
            This comprehensive trip to Israel will take you from Mount Hermon in
            the far north to the Red Sea in the far south. It also includes an
            exciting day trip to Petra in Jordan. This is truly the cadillac of
            Holy Land tours.{" "}
          </p>
        </div>
        <div>
          <AboutGuide />
        </div>
      </div>
    </div>
  );
}

export default Homepage;
